// extracted by mini-css-extract-plugin
export default {"productBox":"FavoriteProducts_productBox__y3-5k","carouselContainer":"FavoriteProducts_carouselContainer__4I21b","productGrid":"FavoriteProducts_productGrid__DLehQ"};